// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M15.4142 1H3V23H13.3276C12.1768 22.0565 11.498 20.6405 11.498 19.1336V11.5H21V6.58579L15.4142 1ZM14.5 7.5V3L19 7.5H14.5Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M13.498 13.5H22.498V19.1336C22.498 20.1466 21.9868 21.0912 21.1388 21.6452L17.998 23.6969L14.8573 21.6452C14.0093 21.0912 13.498 20.1466 13.498 19.1336V13.5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-file-safety-filled')
export default class FileSafetyFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'file-safety-filled',
    }
  }
}
